import { Link, Text } from '@medly-components/core';
import { Header } from 'components';
import Styled from 'components/common/Styled';
import { SUPPORT_EMAIL_ADDRESS } from 'constants/common';
import {
    MAP_INFO,
    ABOUT_MAP_QUESTION,
    ABOUT_MAP_PARA1,
    ABOUT_MAP_PARA2,
    HOW_TO_USE_MAP,
    HOW_TO_USE_MAP_PARA1,
    HOW_TO_USE_MAP_PARA2,
    ISSUES_WITH_MAP,
    CONTACT_ADMIN,
    MAP_INFO_HEADER
} from 'constants/map';
import { FC } from 'react';
import { Legends } from '../components/Legends/Legends';
import {
    MapPageWrapper,
    HeaderStyled,
    MapInfoHeader,
    MapContent,
    MapInfoBlueBar,
    MapContact,
    MapTextBox,
    AccordianText
} from './MapInfo.styled';
import { useTheme } from 'styled-components';

export const MapInfo: FC = () => {
    const theme = useTheme();
    return (
        <MapPageWrapper>
            <HeaderStyled>
                <Header.LeftSide>
                    <Header.BackButton />
                </Header.LeftSide>
            </HeaderStyled>
            <MapContent>
                <MapInfoHeader textVariant="h2">{MAP_INFO}</MapInfoHeader>
                <MapInfoBlueBar>
                    <Text style={{ padding: '1.9rem 0 2.1rem 3.2rem' }} textVariant="h3" textWeight="Medium">
                        {MAP_INFO_HEADER}
                    </Text>
                </MapInfoBlueBar>
                <MapContact textVariant="body1">
                    <AccordianText textVariant="body1">{ISSUES_WITH_MAP}&nbsp;</AccordianText>
                    <Link href={`mailto:${SUPPORT_EMAIL_ADDRESS}`} style={{ color: theme.colors.coral[500], fontWeight: 500 }}>
                        {CONTACT_ADMIN}
                    </Link>
                </MapContact>
                <MapTextBox>
                    <AccordianText textVariant="h4" style={{ paddingBottom: '1.6rem' }}>
                        {ABOUT_MAP_QUESTION}
                    </AccordianText>

                    <AccordianText style={{ paddingBottom: '1.6rem' }} textVariant="body2">
                        {ABOUT_MAP_PARA1}
                    </AccordianText>
                    <AccordianText textVariant="body2">{ABOUT_MAP_PARA2}</AccordianText>
                </MapTextBox>
                <Styled.NoBgBox style={{ padding: '1.2rem' }} />
                <MapTextBox>
                    <AccordianText textVariant="h4" style={{ paddingBottom: '1.6rem' }}>
                        {HOW_TO_USE_MAP}
                    </AccordianText>

                    <AccordianText textVariant="body2">{HOW_TO_USE_MAP_PARA1}</AccordianText>
                    <Legends />
                    <AccordianText style={{ paddingTop: '1.6rem' }} textVariant="body2">
                        {HOW_TO_USE_MAP_PARA2}
                    </AccordianText>
                </MapTextBox>
            </MapContent>
        </MapPageWrapper>
    );
};

MapInfo.displayName = 'MapInfo';
